import { actionize, apiFetch, apiAction } from 'utils';
import { normalize, Schema } from 'normalizr';
import DuckEntity from './DuckEntity';

const baseEntity = new DuckEntity('splitDeposits');

let types = {
  COMPLETE_MANUAL_PAYMENT_BEGIN: null,
  COMPLETE_MANUAL_PAYMENT_SUCCESS: null,
  COMPLETE_MANUAL_PAYMENT_ERROR: null,
  UNCOMPLETE_MANUAL_PAYMENT_BEGIN: null,
  UNCOMPLETE_MANUAL_PAYMENT_SUCCESS: null,
  UNCOMPLETE_MANUAL_PAYMENT_ERROR: null
};
types = actionize(types, (action) => `schooladmin/splitDeposits/${action}`);

const completeManualPayment = (object, payment_method, paid_date, received_date) => apiAction(
  types.COMPLETE_MANUAL_PAYMENT_BEGIN, types.COMPLETE_MANUAL_PAYMENT_SUCCESS, types.COMPLETE_MANUAL_PAYMENT_ERROR,
  (state) => apiFetch.post(state, `${baseEntity.config.apiPath}/${object.id}/complete_manual_payment`, {payment_method, paid_date, received_date}, {}),
  {entity: object, entityName: baseEntity.name, create: false, update: true},
  {split_deposit: baseEntity.schema}
);

const unCompleteManualPayment = (object) => apiAction(
  types.UNCOMPLETE_MANUAL_PAYMENT_BEGIN, types.UNCOMPLETE_MANUAL_PAYMENT_SUCCESS, types.UNCOMPLETE_MANUAL_PAYMENT_ERROR,
  (state) => apiFetch.post(state, `${baseEntity.config.apiPath}/${object.id}/uncomplete_manual_payment`, {}, {}),
  {entity: object, entityName: baseEntity.name, create: false, update: true},
  {split_deposit: baseEntity.schema}
);

export default baseEntity.reducer;

export const entity = {
  ...baseEntity,
  actions: {
    ...baseEntity.actions,
    completeManualPayment,
    unCompleteManualPayment
  }
};
